import { Avatar, Box, Chip, Stack, Typography } from "@mui/material";

import { ISOStringToRelativeTime } from "utils";

interface QuestionCardProps {
  qa: QuoteQA;
}

export function QuestionCard({ qa }: QuestionCardProps) {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      {/* Question Header */}
      <Box
        sx={{
          backgroundColor: "grey.50",
          px: 2,
          py: 1.5,
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={2}
        >
          <Box flex={1}>
            <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
              <Typography variant="body1" fontWeight={600}>
                {qa.question.role.user.first_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                asked {ISOStringToRelativeTime(qa.question.created_at)}
              </Typography>
            </Stack>
            <Typography
              variant="body1"
              fontWeight={500}
              fontSize={20}
              sx={{ whiteSpace: "pre-line" }}
            >
              {qa.question.text}
            </Typography>
          </Box>
          <Chip
            label={qa.answer ? "ANSWERED" : "PENDING"}
            size="medium"
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              textTransform: "uppercase",
              backgroundColor: qa.answer ? "success.light" : "#fff3cd",
              color: qa.answer ? "white" : "#856404",
              border: "1px solid",
              borderColor: qa.answer ? "success.main" : "#e6ac00",
            }}
          />
        </Stack>
      </Box>

      {/* Answer or Pending State */}
      <Box sx={{ px: 2, py: 1.5, backgroundColor: "background.paper" }}>
        {qa.answer ? (
          <Stack direction="row" spacing={1.5}>
            <Box
              sx={{
                width: 4,
                backgroundColor: "primary.main",
                borderRadius: 1,
                flexShrink: 0,
                mt: 0.5,
              }}
            />
            <Box flex={1}>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <Avatar sx={{ width: 32, height: 32, fontSize: "14px" }}>
                  {qa.answer.role.company.name.charAt(0)}
                </Avatar>
                <Typography variant="body1" fontWeight={500}>
                  {qa.answer.role.company.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  replied {ISOStringToRelativeTime(qa.answer.created_at)}
                </Typography>
              </Stack>
              <Typography
                variant="body1"
                color="text.primary"
                sx={{ lineHeight: 1.6, whiteSpace: "pre-line" }}
                fontSize={18}
              >
                {qa.answer.text}
              </Typography>
            </Box>
          </Stack>
        ) : (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 6,
                height: 6,
                backgroundColor: "#f39c12",
                borderRadius: "50%",
              }}
            />
            <Typography variant="body2" color="text.secondary">
              Waiting for carrier response...
            </Typography>
          </Stack>
        )}
      </Box>
    </Box>
  );
}
